import { defineStore } from 'pinia'

export const useFiltersStore = defineStore('filters', {
  state: () => {
    return {
      filters: {},
      shownFilters: {},
      orderByColumn: {},
      orderDirection: {},
      perPage: {},
    }
  },
  actions: {
    async clearCache() {
      this.filters = {}
      this.shownFilters = {}
      this.orderByColumn = {}
      this.orderDirection = {}
      this.perPage = {}
    },
  },
  persist: {
    key: `${import.meta.env.VITE_STORE_PREFIX}-filters`,
  },
})
